export function removeComments(str:string):string {
	return str.replace('<!--', '').replace('-->', '');
}
